/* ============================================================
   MeAyurv — Article (blog post) progressive enhancement.
   Works on the rich-text article body that merchants author in the
   Shopify editor — NOTHING here is per-article hardcoded:
     • reading progress bar
     • auto Table of Contents from the body's <h2>s + scroll-spy
     • lede (first real paragraph) styling
     • icon chip before each <h2> (mapped from a leading emoji or a keyword)
     • benefit <ol> colon cleanup (so "<strong>Title</strong>: desc" reads clean)
     • FAQ auto-accordion (an <h2> containing "FAQ"/"Question" + the next <ul>
       of "<strong>Q</strong><br>A" items → collapsible items)
     • moves the server-rendered product CTA to just above the FAQ (if present)
   Init-guarded so a Shopify section re-render can't stack listeners.
   ============================================================ */
(function () {
  if (window.__meayurvArticleInit) return;
  window.__meayurvArticleInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // strip a leading emoji / symbol run (and following space) from a heading label
  var EMOJI_RE = /^[\u{1F000}-\u{1FAFF}\u{2190}-\u{21FF}\u{2300}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE00}-\u{FE0F}\u{200D}\u{2022}\s]+/u;
  function cleanLabel(s) { return (s || '').replace(EMOJI_RE, '').trim(); }

  function slugify(s) {
    return cleanLabel(s).toLowerCase()
      .replace(/['’"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .slice(0, 60) || 'section';
  }

  // icon set (inline SVG path markup, currentColor)
  var ICONS = {
    leaf: '<path d="M11 20a7 7 0 0 1-7-7c0-5 4-9 9-9 5 0 7 3 7 3s-2 13-9 13z"/><path d="M5 19c4-1 7-4 9-9"/>',
    sparkles: '<path d="m12 3 1.9 4.8L18 9.7l-4.1 1.9L12 16l-1.9-4.4L6 9.7l4.1-1.9z"/><path d="M19 14l.7 1.8L21 16.5l-1.3.7L19 19l-.7-1.8L17 16.5l1.3-.7z"/>',
    bowl: '<path d="M3 11h18"/><path d="M5 11a7 7 0 0 0 14 0"/><path d="M9 7c0-1 .5-2 1.5-2.5"/><path d="M13 7c0-1 .5-2 1.5-2.5"/>',
    shield: '<path d="M12 3l7 3v5c0 4.4-3 8.3-7 9-4-.7-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/>',
    faq: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 2.5"/><path d="M12 17h.01"/>',
    heart: '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.51 4.04 3 5.5l7 7Z"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.9 4.9 1.4 1.4"/><path d="m17.7 17.7 1.4 1.4"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m4.9 19.1 1.4-1.4"/><path d="m17.7 6.3 1.4-1.4"/>'
  };
  function svg(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || ICONS.leaf) + '</svg>';
  }
  function iconFor(raw) {
    var s = raw || '';
    if (/[🌱🌿🍃]/u.test(s)) return 'leaf';
    if (/[✨⭐🌟]/u.test(s)) return 'sparkles';
    if (/[🥣🍵🥤]/u.test(s)) return 'bowl';
    if (/[🛡🛡️]/u.test(s)) return 'shield';
    if (/[💡❓🙋]/u.test(s)) return 'faq';
    if (/[❤💖🫀]/u.test(s)) return 'heart';
    if (/[☀🌞]/u.test(s)) return 'sun';
    var t = cleanLabel(s).toLowerCase();
    if (/faq|question|answer/.test(t)) return 'faq';
    if (/benefit|why .* good|top /.test(t)) return 'sparkles';
    if (/how to use|usage|use it|ritual|recipe|dosage|dose/.test(t)) return 'bowl';
    if (/why meayurv|why our|our |purity|pure|quality|lab|sourc/.test(t)) return 'shield';
    if (/skin|hair|glow|beauty/.test(t)) return 'heart';
    if (/energy|immun|detox|wellness|health/.test(t)) return 'sun';
    return 'leaf';
  }

  ready(function () {
    var body = document.querySelector('[data-may-art-body]');
    if (!body) return;

    /* ---- progress bar ---- */
    var fill = document.querySelector('[data-may-art-progress]');
    if (fill) {
      var onScroll = function () {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var pct = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
        fill.style.width = pct + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- lede: first paragraph with real text ---- */
    var paras = body.querySelectorAll(':scope > p');
    for (var i = 0; i < paras.length; i++) {
      if (paras[i].textContent.trim().length > 0) { paras[i].classList.add('may-art__lede'); break; }
    }

    /* ---- benefit <ol>: drop the leading ":" after a bold lead-in ---- */
    body.querySelectorAll(':scope > ol > li').forEach(function (li) {
      var strong = li.firstElementChild;
      if (strong && strong.tagName === 'STRONG') {
        var n = strong.nextSibling;
        if (n && n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/^\s*[:\-–—]\s*/, ' ');
      }
    });

    /* ---- headings: id + icon chip, collect for TOC ---- */
    var heads = body.querySelectorAll(':scope > h2');
    var toc = [];
    heads.forEach(function (h) {
      var raw = h.textContent;
      var label = cleanLabel(raw);
      if (!h.id) h.id = slugify(raw);
      if (!h.querySelector('.may-art__h2icon')) {
        var icon = document.createElement('span');
        icon.className = 'may-art__h2icon';
        icon.innerHTML = svg(iconFor(raw));
        var txt = document.createElement('span');
        txt.className = 'may-art__h2text';
        txt.textContent = label;
        h.textContent = '';
        h.appendChild(icon);
        h.appendChild(txt);
        h.classList.add('may-art__h2');
      }
      toc.push({ id: h.id, label: label, el: h });
    });

    /* ---- FAQ accordion: an <h2> reading "FAQ"/"Questions" + the next <ul> of
       "<strong>Q</strong><br>A" items (the STANDARD format — see bloginstructions.md §4). ---- */
    var faqHead = toc.filter(function (s) { return /faq|question|answer/i.test(s.label); })[0];
    if (faqHead) {
      var ul = faqHead.el.nextElementSibling;
      while (ul && ul.tagName !== 'UL' && ul.tagName !== 'H2') ul = ul.nextElementSibling;
      if (ul && ul.tagName === 'UL') {
        var acc = document.createElement('div');
        acc.className = 'may-art-faq';
        ul.querySelectorAll(':scope > li').forEach(function (li) {
          var clone = li.cloneNode(true);
          var q = '', a = '';
          var lead = clone.querySelector('strong');
          if (lead) {
            q = lead.textContent.trim();
            lead.remove();
            a = clone.innerHTML.replace(/^\s*(<br\s*\/?>|:|\-|–|—)\s*/i, '').trim();
          } else {
            var parts = clone.innerHTML.split(/<br\s*\/?>/i);
            q = (parts.shift() || '').replace(/<[^>]+>/g, '').trim();
            a = parts.join('<br>').trim();
          }
          if (!q) return;
          // a "TL;DR" lead-in is a summary, not a question — keep it out of the FAQ accordion
          if (/^TL\s*;?\s*DR\b/i.test(q)) return;
          var item = document.createElement('div');
          item.className = 'may-art-faq__item';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'may-art-faq__q';
          btn.setAttribute('aria-expanded', 'false');
          var qspan = document.createElement('span');
          qspan.textContent = q;
          btn.appendChild(qspan);
          btn.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>');
          var panel = document.createElement('div');
          panel.className = 'may-art-faq__a';
          var inner = document.createElement('div');
          inner.innerHTML = a;
          panel.appendChild(inner);
          btn.addEventListener('click', function () {
            var open = item.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
          item.appendChild(btn);
          item.appendChild(panel);
          acc.appendChild(item);
        });
        if (acc.children.length) ul.replaceWith(acc);
      }
    }

    /* ---- move the product CTA above the FAQ heading (if both exist) ---- */
    var cta = document.querySelector('[data-may-art-cta]');
    if (cta && faqHead && faqHead.el && faqHead.el.parentNode === body) {
      body.insertBefore(cta, faqHead.el);
    }

    /* ---- build the TOC (desktop aside + mobile details) + scroll-spy ---- */
    if (toc.length >= 2) {
      var desktop = document.querySelector('[data-may-art-toc]');
      var mobile = document.querySelector('[data-may-art-toc-mobile]');
      var links = [];
      function makeLink(s, cls) {
        var a = document.createElement('a');
        a.href = '#' + s.id;
        a.className = cls;
        a.textContent = s.label;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var el = document.getElementById(s.id);
          if (!el) return;
          var top = el.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top: top, behavior: 'smooth' });
          if (mobile) mobile.removeAttribute('open');
        });
        return a;
      }
      if (desktop) {
        toc.forEach(function (s) {
          var a = makeLink(s, 'may-art-toc__link');
          desktop.appendChild(a);
          links.push({ id: s.id, a: a });
        });
      }
      if (mobile) {
        var mnav = mobile.querySelector('[data-may-art-toc-mobile-list]');
        if (mnav) toc.forEach(function (s) { mnav.appendChild(makeLink(s, 'may-art-toc-m__link')); });
      }
      if (links.length) {
        var ids = toc.map(function (s) { return s.id; });
        var spy = function () {
          var current = ids[0];
          for (var j = 0; j < ids.length; j++) {
            var el = document.getElementById(ids[j]);
            if (el && el.getBoundingClientRect().top <= 140) current = ids[j];
          }
          links.forEach(function (l) { l.a.classList.toggle('is-active', l.id === current); });
        };
        window.addEventListener('scroll', spy, { passive: true });
        spy();
      }
    } else {
      // not enough headings → hide the empty TOC shell
      var shell = document.querySelector('[data-may-art-toc-shell]');
      if (shell) shell.style.display = 'none';
      var mshell = document.querySelector('[data-may-art-toc-mobile]');
      if (mshell) mshell.style.display = 'none';
    }

    /* ---- share buttons ---- */
    var copyBtn = document.querySelector('[data-may-art-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-url') || location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            copyBtn.classList.add('is-copied');
            setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1600);
          });
        }
      });
    }
  });
})();
